import React from "react"
import styled from "styled-components"
import { Container, Row, Col } from "reactstrap"
import vars from "styles/variables"

function Footer(props) {
  return (
    <StyledFooter>
      <Container>
        <Row>
          <Col>&copy; Inspired Agency {new Date().getFullYear()}</Col>
        </Row>
      </Container>
    </StyledFooter>
  )
}

export default Footer

const StyledFooter = styled.footer`
  padding: 1rem 0;
  background: ${vars.grey_200};
`
